<template>
  <div class="animated fadeIn">
    <b-modal ref="modal-simulacao" scrollable centered button-size="sm">
      <template #modal-title>
      <i class="fas fa-map-marker-alt"></i> NOVA SIMULAÇÃO
      </template>

      <div class="form-group row pt-2">
        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Data:</label>
          <div class="input-group">
            <b-form-input type="date"
              v-model="form.data.value"
              :required="form.data.required"
              :disabled="true"
              :state="form.data.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Total:</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.valorTotal.value"
              :required="form.valorTotal.required"
              @change="onCalculateValorParcela"
              :state="form.valorTotal.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Parcelas:</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.quantidadeParcelas.value"
              :required="form.quantidadeParcelas.required"
              @change="onCalculateValorParcela"
              :state="form.quantidadeParcelas.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Taxa de Juros (%):</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.taxaJuros.value"
              :required="form.taxaJuros.required"
              @change="onCalculateValorParcela"
              :state="form.taxaJuros.state"
              :min="0"
              :max="100"
              :step="0.01"></b-form-input>
          </div>
        </div>

        <hr />

        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Valor da Parcela:</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="form.valorParcela.value"
              :required="form.valorParcela.required"
              :disabled="true"
              :state="form.valorParcela.state"></b-form-input>
          </div>
        </div>

        <div class="col-md-12 pb-2">
          <label><small class="text-danger">*</small> Valor Total (com juros):</label>
          <div class="input-group">
            <b-form-input type="number"
              v-model="valorComJuros"
              :required="false"
              :disabled="true"></b-form-input>
          </div>
        </div>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <button @click.prevent="onSave"
                  type="button"
                  class="btn btn-third btn-sm"
                  v-b-tooltip.hover
                  title="Salvar">
            <i class="fas fa-check-circle"></i>
            <span class="d-md-down-none"> Salvar</span>
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script>
import SimulacaoModal from './simulacaomodal.js'
export default SimulacaoModal
</script>



// WEBPACK FOOTER //
// src/views/private/crm/details/simulacao/modal/simulacaomodal.vue